import React, { useState } from 'react';
import BoxResaleCreditCard from './BoxResaleCreditCard';
import { getUserToken } from "../../shared/utils";
import jwt_decode from "jwt-decode";
import { formatCurrency } from '../../../../js/shared/utils';
import { isMobile } from '../../../../js/components/searchform/utils/common';
import BoxResaleReusingMiles from './BoxResaleReusingMiles';
import BoxResaleTransfer from './BoxResaleTransfer'

const ResaleForm = props => {
    const { total, percent, totalDiscounted, closeResale } = props;
    {/* Não remover - ACQ-504 Ocultando opção tranferência */ }
    // const [paymentType, setPaymentType] = useState({ creditCard: undefined, transfer: undefined });
    const [paymentType, setPaymentType] = useState({ creditCard: true, transfer: undefined, reusingMiles: undefined });

    const handleChange = value => {
        const paymentTypeParse = {
            'credit-card': { creditCard: true, transfer: false, reusingMiles: false },
            'transfer': { creditCard: false, transfer: true, reusingMiles: false },
            'reusing-miles': { creditCard: false, transfer: false, reusingMiles: true }
        };

        setPaymentType(paymentTypeParse[value]);
    }

    const { creditCard, transfer, reusingMiles } = paymentType;

    return (
        <div className="resale-form">
            <h1 className="resale-form__title">Débito em aberto</h1>

            <h5>Como você prefere quitar esse débito?</h5>
            <h6>Escolha a melhor forma de regularizar sua situação</h6>
            <div className="resale-form__box-methods-payment">
                <div
                    onClick={() => handleChange('credit-card')}
                    className={`resale-form__box-radio resale-form__box-radio--credit-card ${creditCard && 'bg-green-light'}`}
                >
                    <input type="radio" id="credit-card" name="method-payment" value="credit-card" checked={creditCard} onClick={e => handleChange(e.target.value)} />
                    <label htmlFor="credit-card"><span></span>Cartão de crédito</label>
                </div>

                <div
                    onClick={() => handleChange('reusing-miles')}
                    className={`resale-form__box-radio resale-form__box-radio--reusing-miles ${reusingMiles && 'bg-green-light'}`}
                >
                    <input type="radio" id="reusing-miles" name="method-payment" value="reusing-miles" checked={reusingMiles} onClick={e => handleChange(e.target.value)} />
                    <label htmlFor="reusing-miles"><span></span>Reutilizar milhas</label>
                </div>

                {/* Não remover - ACQ-504 Ocultando opção tranferência */}
                {/*
                <div
                    onClick={() => handleChange('transfer')}
                    className={`resale-form__box-radio resale-form__box-radio--transfer ${transfer && 'bg-green-light'}`}
                >
                    <input type="radio" id="transfer" name="method-payment" value="transfer" checked={transfer} onClick={e => handleChange(e.target.value)} />
                    <label htmlFor="transfer"><span></span>Transferência bancária</label>
                    <div className="resale-form__percent">
                        <span>{`(${percent}% de desconto)`}</span>
                    </div>
                </div>
                */}
            </div>

            {!reusingMiles && (
                <div className="resale-form__price">
                    <p>{`Valor do débito${transfer ? ' com desconto:' : ':'}`} <span>{transfer ? formatCurrency(totalDiscounted || 0) : formatCurrency(total || 0)}</span></p>
                </div>
            )}

            {/* Não remover - ACQ-504 Ocultando opção tranferência */}
            {/* {transfer && <BoxResaleTransfer closeResale={closeResale} /> } */}

            { creditCard &&
                <div className="credit-card">
                    <BoxResaleCreditCard closeResale={closeResale} total={total}/>
                </div>
            }

            {reusingMiles && <BoxResaleReusingMiles closeResale={closeResale} />}

        </div>
    )
}

export default ResaleForm;